"use client";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useSession } from "next-auth/react";
import { useState } from "react";
import Link from "~/components/Link";
import NotificationBell from "~/components/navbar/NotificationBell";
import { useUnpaidOrders } from "~/components/providers/UnpaidOrdersContext";
import UserAvatar from "./UserAvatar";
import UserMenu from "./UserMenu";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function StoreFrontRightArea({ hideConnectButton = false }: { hideConnectButton?: boolean }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { hasDismissedUnpaidOrders } = useUnpaidOrders();

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const { data: session, status } = useSession();
  const user = session?.user;

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", ml: { xs: "auto", md: 0 } }}
    >
      {user?.role === "admin" && (
        <Link
          button
          href="/admin"
          color="inherit"
          startIcon={<AdminPanelSettingsIcon />}
          sx={{
            fontWeight: 400,
            display: { xs: "none", md: "inline-flex" },
          }}
        >
          Admin
        </Link>
      )}

      {user ? (
        <>
          <NotificationBell />
          <Tooltip title="Contul meu">
            <IconButton
              onClick={handleProfileMenuOpen}
              aria-label="Contul Meu"
              sx={{
                p: 0.25,
                ml: 1,
              }}
            >
              <UserAvatar
                user={user}
                size={32}
                showWarning={hasDismissedUnpaidOrders}
              />
            </IconButton>
          </Tooltip>
          <UserMenu anchorEl={anchorEl} onClose={handleProfileMenuClose} />
        </>
      ) : (
        status !== "loading" && !hideConnectButton && (
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1 }}>
            <Link button href="/login" color="inherit">
              Conectare
            </Link>
          </Box>
        )
      )}
    </Box>
  );
}
